import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { INumericValue } from '../../interfaces/numeric-value.interface';
import { Observable } from 'rxjs/Observable';

const BATTERY_PERCENTAGE_REMAINING_MIN = 0;
const BATTERY_PERCENTAGE_REMAINING_MAX = 255;
const CACHE_TIME: number = 3600;

export class PowerConfigurationServerPlugin extends SmartenitPlugin
  implements INumericValue {
  public onInit() {
    this.state.batteryPercentageRemaining = 0;

    this.getCache('battery_percentage_remaining').subscribe((percentage) => {
      if (percentage !== undefined) {
        this.state.batteryPercentageRemaining = percentage;
      }
    });
  }

  public getReportableAttrs() {
    return ['BatteryPercentageRemaining'];
  }

  public getValue(attribute?: string): number {
    const response: number = Number(this.state.batteryPercentageRemaining);
    return response;
  }

  public setValue(value: number, attribute?: string, subscribe?: boolean): any {
    // Do nothing becase values are read only
    if (subscribe) {
      return Observable.of(true);
    }
    return true;
  }

  public getConditionAttribute(): string {
    return 'BatteryPercentageRemaining';
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public getUnit(attribute?: string): string {
    return '%';
  }

  public getConditionOptions(): any {
    return null;
  }

  public getEffectOptions(): any {
    return null;
  }

  public getStatus(context?: string, subscribe?: boolean): any {
    this.getCache('battery_percentage_remaining').subscribe(
      (percentage: any) => {
        if (percentage == null) {
          this.getAttributeWithSubscribeOption(
            this.componentId,
            this.processorName,
            'BatteryPercentageRemaining',
            null,
            false,
            `cacheTTL=${CACHE_TIME}`
          );
        } else {
          this.state.batteryPercentageRemaining = percentage;
          this._onUpdate.next(percentage);
        }
      }
    );
  }

  public getStatusPayload(): any {
    return ['BatteryPercentageRemaining'];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const response = message && message.data && message.data.response;
    const attributeOrMethod = message && message.attributeOrMethod;
    const value = response.value;

    if (attributeOrMethod === 'BatteryPercentageRemaining') {
      const percentage = parseInt(value) / 2;
      this.setCache(
        'battery_percentage_remaining',
        percentage,
        CACHE_TIME,
        undefined,
        timestamp
      );
      this.state.batteryPercentageRemaining = percentage;
      this._onUpdate.next(percentage);
    }

    return this.state;
  }

  public getRawValue(
    value: number,
    attribute?: string,
    method?: string
  ): number {
    if (!attribute || attribute === 'BatteryPercentageRemaining') {
      return this.pluginUtilsService.getValueFromPercentage(
        value,
        BATTERY_PERCENTAGE_REMAINING_MIN,
        BATTERY_PERCENTAGE_REMAINING_MAX
      );
    } else {
      return value;
    }
  }

  public getProcessedValue(value: any, attribute?: string, method?: string) {
    if (!attribute || attribute === 'BatteryPercentageRemaining') {
      return this.pluginUtilsService.getValueToPercentage(
        value,
        BATTERY_PERCENTAGE_REMAINING_MIN,
        BATTERY_PERCENTAGE_REMAINING_MAX
      );
    } else {
      return value;
    }
  }
}
